<template>
  <div class="box">
    <div class="header">
      <h2>{{ title }}</h2>
    </div>
    <slot></slot>
  </div>
</template>

<script lang="ts">
import { defineComponent, PropType, VNode } from "vue";

export default defineComponent({
  name: "Headerbox",
  props: {
    title: {
      type: String,
      required: true,
    },
    children: {
      type: [Object, Array] as PropType<VNode>,
      default: null,
    },
  },
});
</script>

<style scoped>
@import "./Headerbox.css";
</style>